
























































import Vue from 'vue'
import _ from 'lodash'
import { ResourceDenfinitionServiceProxy } from '@/service-proxies/app-v2/api.service-proxies'
import { AppCardScopeServiceProxy } from '@/service-proxies/app-v2/system.service-proxies'

const resourceDenfinitionServiceProxy = new ResourceDenfinitionServiceProxy()
const appCardScopeServiceProxy = new AppCardScopeServiceProxy()

export default Vue.extend({
  name: 'AddPermission',
  props: {
    visible: {
      // 是否展示
      type: Boolean,
      default: false
    },
    appInfo: {
      type: Object,
      default: () => {
        return {}
      }
    },
    cardInfo: {
      type: Object
    }
  },
  data() {
    return {
      form: this.$form.createForm(this),
      formData: {
        httpMethod: '',
        scopePath: '',
        scopeName: '',
        resourceCode: ''
      },
      remark: '', // 暂时不传,后端无对应字段
      appCode: '',
      interfaceName: '',
      fetching: false,
      loading: false,
      serviceList: [],
      apiList: [],
      apiItemList: [],
      cardId: ''
    }
  },
  watch: {
    cardInfo: {
      handler(val) {
        this.cardId = val.id
      },
      deep: true,
      immediate: true
    },
    visible: {
      handler(val) {
        this.formData = {
          httpMethod: '',
          scopePath: '',
          scopeName: '',
          resourceCode: ''
        }
        this.remark = ''
        this.serviceList = []
        this.appCode = ''
        this.apiList = []
        this.interfaceName = ''
      },
      immediate: true
    },
    appCode(val) {
      this.apiList = []
      this.interfaceName = ''
    }
  },
  created() {
    this.getServiceList = _.debounce(this.getServiceList, 800)
    this.getApiList = _.debounce(this.getApiList, 800)
  },
  methods: {
    handleCancel() {
      this.$emit('close')
    },
    handleOk() {
      this.loading = true
      let params: any = {
        cardId: this.cardId,
        ...this.formData
      }
      appCardScopeServiceProxy.relatePermission(params).then(
        (res: any) => {
          if (res) {
            this.$message.success('新增成功！')
            this.$emit('close', true)
          }
        }).finally(()=>{
        this.loading = false
      })
    },
    handleServiceChange(value: any) {
      // console.log(`appCode:`, this.appCode)
    },
    handleApiChange(value: any) {
      if (value) {
        this.apiItemList.map((item: any) => {
          if (item.code === value) {
            // console.log('item:', item)
            let { httpMethod, code, url, name } = item
            this.formData.httpMethod = httpMethod
            this.formData.resourceCode = code
            this.formData.scopeName = name
            this.formData.scopePath = url
          }
        })
      }
    },
    getServiceList(value: any) {
      if (!value) {
        return
      }
      this.serviceList = []
      this.fetching = true
      resourceDenfinitionServiceProxy.selectResourceDefinitionByAppCode(value).then(
        (res: any) => {
          if (res) {
            this.serviceList = res
          }
        }).finally(()=>{
        this.fetching = false
      })
    },
    getApiList(value: any) {
      if (!value) {
        return
      }
      if (!this.appCode) {
        this.$message.error('请先选择服务!')
      }
      this.apiList = []
      this.apiItemList = []
      this.fetching = true
      resourceDenfinitionServiceProxy.queryResourceInfo(this.appCode, value).then(
        (res: any) => {
          if (res) {
            this.apiItemList = res
            let tempArr: any = []
            res.map((item: any) => {
              tempArr.push(item.code)
            })
            this.apiList = [...tempArr]
          }
        }).finally(()=>{
        this.fetching = false
      })
    }
  }
})
